import Card from 'antd/es/card/Card';
import React, { Component } from 'react';
import { GamesTable } from '../components';
import { AppContext, AppContextValue } from '../../../theme/AppContextProvider';
import { GamesTableMobile } from '../components/GamesTableMobile';
import { CreateGamePanel } from '../components/CreateGamePanel';

interface IProps {
  title: string;
}

class _CommonGamePage extends Component<IProps> {
  static contextType = AppContext;

  render() {
    const { isMobile } = this.context as AppContextValue;
    const TableComponent = isMobile ? GamesTableMobile : GamesTable;

    if (isMobile) {
      return <TableComponent />;
    }

    return (
      <Card bordered={false} title={this.props.title} style={{ marginBottom: 8 }}>
        <CreateGamePanel />
        <TableComponent />
      </Card>
    );
  }
}

export const CommonGamePage = _CommonGamePage;
